var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import IconButton from "../../Button/IconButton";
export default styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n"], ["\n  position: absolute;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), theme.spacing.one, theme.spacing.four);
});
var templateObject_1, templateObject_2;
